import { render, staticRenderFns } from "./Prescribing.vue?vue&type=template&id=30e9667b&scoped=true"
import script from "./Prescribing.vue?vue&type=script&lang=js"
export * from "./Prescribing.vue?vue&type=script&lang=js"
import style0 from "./Prescribing.vue?vue&type=style&index=0&id=30e9667b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9667b",
  null
  
)

export default component.exports